<section class="cart-page-shell" [attr.lang]="language()">
  <header class="cart-header">
    <div>
      <h1>{{ t('title') }}</h1>
      <p>{{ t('invoiceHint') }}</p>
    </div>
    <button type="button" class="ghost-btn" (click)="goBack()">{{ t('backToProducts') }}</button>
  </header>

  @if (cartRows().length === 0) {
    <section class="invoice-card empty-card">
      <p>{{ t('empty') }}</p>
      <button type="button" (click)="goBack()">{{ t('backToProducts') }}</button>
    </section>
  } @else {
    <section class="invoice-card">
      <div class="invoice-topbar">
        <div>
          <h2>{{ t('invoiceTitle') }}</h2>
          <p>{{ t('orderRef') }}: {{ invoiceRef() }}</p>
        </div>
        <div class="invoice-meta-right">
          <p>{{ t('issueDate') }}: {{ issueDate | date : 'yyyy-MM-dd' }}</p>
        </div>
      </div>

      <div class="mobile-lines">
        @for (item of cartRows(); track trackByCartProductID($index, item)) {
          <article class="line-card">
            <div class="line-card-head">
              <strong>#{{ $index + 1 }} {{ item.productName }}</strong>
              <button type="button" class="danger-ghost" (click)="removeItem(item)">{{ t('remove') || 'Remove' }}</button>
            </div>

            <div class="line-grid">
              <div class="line-meta">
                <span>{{ t('quantity') }}</span>
                <input
                  type="number"
                  [min]="item.packageSize"
                  [step]="item.packageSize"
                  [value]="item.quantity"
                  (input)="setQuantity(item, $any($event.target).value)"
                />
                <small class="pack-note">{{ t('packIncrementHint') }} {{ item.packageSize }}</small>
              </div>
              <div class="line-meta">
                <span>{{ t('packSize') }}</span>
                <strong>{{ item.packageSize }}</strong>
              </div>
              <div class="line-meta">
                <span>{{ t('unitPrice') }}</span>
                <strong>{{ (item.unitPriceCents / 100) | moneyComma }}</strong>
              </div>
              <div class="line-meta">
                <span>{{ t('tax') }} %</span>
                <strong>{{ item.taxPercentage.toFixed(2) }}%</strong>
              </div>
              <div class="line-meta">
                <span>{{ t('tax') }}</span>
                <strong>{{ lineTax(item) | moneyComma }}</strong>
              </div>
              <div class="line-meta">
                <span>{{ t('lineTotal') }}</span>
                <strong>{{ lineTotal(item) | moneyComma }}</strong>
              </div>
            </div>
          </article>
        }
      </div>

      <div class="invoice-summary">
        <div><span>{{ t('subtotal') }}</span><strong>{{ subtotal() | moneyComma }}</strong></div>
        <div><span>{{ t('taxAdded') }}</span><strong>{{ taxTotal() | moneyComma }}</strong></div>
        <div class="grand-total"><span>{{ t('grandTotal') }}</span><strong>{{ grandTotal() | moneyComma }}</strong></div>
      </div>

      <div class="invoice-actions">
        <button type="button" class="ghost-btn" (click)="clearCart()">{{ t('clearCart') || 'Clear Cart' }}</button>
        <button type="button" class="primary-btn" [disabled]="placeOrderInFlight()" (click)="placeOrder()">
          {{ placeOrderInFlight() ? t('placingOrder') : t('placeOrder') }}
        </button>
      </div>

      @if (submitted() && placeOrderMessage()) {
        <p class="order-note" [class.order-note-error]="placeOrderError()">{{ placeOrderMessage() }}</p>
      }
    </section>
  }
</section>
